import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var CheckSmall = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M3.76 8.63a1 1 0 10-1.52 1.3l2.9 2.71a1 1 0 001.5 0l7.1-7a1 1 0 10-1.48-1.35l-6.34 6.2z" })), '0 0 16 16', 'CheckSmall');
//# sourceMappingURL=CheckSmall.js.map